"use client";
import dynamic from "next/dynamic";
import { Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";

// Dynamically import components that use search params
const AppChatProvider = dynamic(() => import("./AppChatProvider"), {
  ssr: false,
});

// Loading component
const LoadingFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
    flexDirection="column"
    gap={2}
  >
    <CircularProgress size={40} />
    <div>Loading chat...</div>
  </Box>
);

export default function AppPage() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <AppChatProvider />
    </Suspense>
  );
}
